





































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, UsuarioActual } from "../login-controlador";
import { Email } from '@/__env/ext';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{
    get Controlador() { return Model; }
    get UsuarioActual() { return UsuarioActual; }

    Estado: 'cargando' | 'iniciado' = 'iniciado';
    Error: string = '';
    Usuario: string = '';

    Siguiente( m: string )
    {
        this.$emit( 'modo', m );
    }

    public async Comprobar()
    {
        if ( this.Usuario.length < 3 )
        {
            this.Error = '¡Ingresá un usuario válido!';
            return;
        }
        else if ( this.Usuario.includes( '@' ) && !Email( this.Usuario ) )
        {
            this.Error = '¡Ingresá un email válido!';
            return;
        }

        this.Estado = 'cargando';
        let response = await this.Controlador.Comprobar( this.Usuario.toLowerCase() );
        if ( !response.resultado )
        {
            this.Usuario = '';
            this.Error = response.mensaje;
            document.getElementById( 'text-usuario' ).focus();
        }
        this.Estado = 'iniciado';
    }

}
